import { render, staticRenderFns } from "./topicAccuracy.vue?vue&type=template&id=dcc5acd4&scoped=true&"
import script from "./topicAccuracy.vue?vue&type=script&lang=js&"
export * from "./topicAccuracy.vue?vue&type=script&lang=js&"
import style0 from "./topicAccuracy.vue?vue&type=style&index=0&id=dcc5acd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc5acd4",
  null
  
)

export default component.exports